import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimeVersionCreatePage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Nouvelle version d'un runtime de l'organisation : ses paquets pip épinglés (ADR 0097). */
export const Route = createFileRoute('/$tenant/runtimes/$runtimeId/versions/new')({
  component: NewRuntimeVersionRoute,
});

function NewRuntimeVersionRoute() {
  const { tenant, runtimeId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[
        { label: t('nav.items.runtimes') },
        { label: <EntityName tenantId={tenant} kind="runtime" id={runtimeId} /> },
        { label: t('admin.runtimes.versions.newTitle') },
      ]}
    >
      <RuntimeVersionCreatePage tenantId={tenant} runtimeId={runtimeId} />
    </ConsoleShell>
  );
}
